import { MovableInk } from 'ui/icons';
import { PanelIntent } from 'modules/movableInk/types';
import { UrlInputIconButton } from './UrlInputIconButton';
import { useTranslations } from '../../hooks/useTranslations';
import { ModalType, useModalContext } from '../../context';

export const DATA_TEST_ID = 'mi-icon-button';

/** used in url input field */
export const MovableInkIconButton = ({
  onSelect,
}: {
  onSelect: (url: string) => void;
}) => {
  const { openModal, closeModal } = useModalContext();
  const { t } = useTranslations();
  const onClose = () => {
    closeModal(ModalType.MovableInk);
  };

  const onClick = () => {
    openModal(ModalType.MovableInk, {
      intent: PanelIntent.Select,
      onSelect,
      onClose,
    });
  };
  return (
    <UrlInputIconButton
      onClick={onClick}
      data-test={DATA_TEST_ID}
      Icon={<MovableInk isColorInherited />}
      tooltipContent={t('tooltip.insertMovableInk')}
    />
  );
};
